var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseButton',{staticClass:"check-in-other-market-button",class:_vm.getBemModifiers(),attrs:{"type":"button","name":_vm.text},nativeOn:{"click":function($event){return _vm.changeShop($event)}}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }